var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.414 -1.238)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3,6H17.828",
    transform: "translate(0 -0.705)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.533,5.3V16.828a1.648,1.648,0,0,1-1.648,1.648H6.648A1.648,1.648,0,0,1,5,16.828V5.3m2.471,0V3.648A1.648,1.648,0,0,1,9.119,2h3.3a1.648,1.648,0,0,1,1.648,1.648V5.3",
    transform: "translate(-0.352 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 5.387,
    transform: "translate(8.619 9.34)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 5.387,
    transform: "translate(12.21 9.34)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.9c7ba26fc464aaf882b0e7d0c978dc17.svg";
export { ForwardRef as ReactComponent };